import { useVillaTranslation } from "@website/accommodation-ui/villa-search/villa-search-panel/hooks/use-villa-translation";
import { VillaSearchNoResult } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-no-result";
import { VillaSearchPanelPropertiesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { useFetcher } from "@website/fetcher/use-fetcher";
import { useDebounce } from "@website/hooks/debounce";
import { MaterialIcon } from "@website/icons/material";
import pick from "lodash-es/pick";
import { useState } from "react";

export const useDestination = ({
  cityTitleInitialValues,
  searchAutocompleteFetcher,
  searchSuggestion
}: { cityTitleInitialValues?: string } & Pick<
  VillaSearchPanelPropertiesType,
  "searchAutocompleteFetcher" | "searchSuggestion"
>) => {
  const [destinationQuery, setDestinationQuery] = useState<string>("");
  const [selectedDestination, setSelectedDestination] = useState<string>("");
  const [selectedDestinationItem, setSelectedDestinationItem] =
    useState<any>(null);
  const query = useDebounce(destinationQuery, 250);
  const { translateEntity } = useVillaTranslation();

  const { isFetching, data } = useFetcher({
    queryKey: ["searchAutocomplete", query],
    enabled: Boolean(query),
    queryFn: ({ queryKey }) => searchAutocompleteFetcher?.(queryKey[1])
  });
  const destinationList =
    query && data && data.length > 0
      ? data
      : searchSuggestion && !isFetching
        ? searchSuggestion
        : [];

  const onChangeDestinationQuery = (value: string) => {
    setDestinationQuery(value);
  };

  const destinationListNormalized = destinationList?.map((item: any) => ({
    ...pick(item, ["id", "title"]),
    subtitle: translateEntity(item.subtitle),
    StartIcon: item.isHotel ? (
      <MaterialIcon name="hotel" variant="outlined" />
    ) : (
      <MaterialIcon name="trip_origin" variant="outlined" />
    ),
    Meta: (
      <div className="text-on-surface-high-emphasis text-caption">
        {item.info}
      </div>
    )
  }));
  const onSelectDestination = (id: string) => {
    setSelectedDestination(id);
    const destinationItem = destinationList.find(
      (destination: any) => `${destination.id}` === `${id}`
    );
    setDestinationQuery("");
    setSelectedDestinationItem(destinationItem);
  };

  const onChangeDestination = (item: any) => {
    setSelectedDestination(item.id);
    setDestinationQuery("");
    setSelectedDestinationItem(item);
  };

  return {
    selectedDestinationItem,
    selectedDestinationText:
      selectedDestinationItem?.title || cityTitleInitialValues,
    destinationQuery,
    selectedDestination,
    onChangeDestination,
    onSelectDestination,
    onChangeDestinationQuery,
    destinationList,
    destinationLoading: isFetching,
    destinationListNormalized,
    DestinationNoResult:
      destinationQuery?.length >= 2 &&
      !isFetching &&
      data &&
      data.length === 0 ? (
        <VillaSearchNoResult query={destinationQuery} />
      ) : undefined
  };
};
